import _ from 'lodash';
import * as api  from '../api';
import {findPatternCells,patternContainsCell} from './common';
import {patternsFoundSingleton} from './patterns-found-singleton';

export const getCurrentPatternInput = (cellVals)=>{
    
    return (pattern)=>{
        
        const chars = [];
        if(pattern.direction === 0){
            for(let i=0;i<pattern.word.length;i++){
                const cellValKey = `${pattern.row}_${pattern.col+i}`;
                chars.push(cellVals[cellValKey]);
            }
        }
        else if(pattern.direction === 1){
            for(let i=0;i<pattern.word.length;i++){
                const cellValKey = `${pattern.row + i}_${pattern.col}`;
                chars.push(cellVals[cellValKey]);
            }
        }
    
        if(chars.filter(c=>c!=='').length === pattern.word.length){
            const word = chars.join('');
            //console.log(`WORD:(${word})`,cellVals);

            return word;

        }
    
    };
};

export const getPatternInputComponent = (cellVals)=>{
    
    return (pattern)=>{
        
        let chars = [];
        if(pattern.direction === 0){
            for(let i=0;i<pattern.word.length;i++){
                const cellValKey = `${pattern.row}_${pattern.col+i}`;
                chars.push(cellVals[cellValKey]);
            }
        }
        else if(pattern.direction === 1){
            for(let i=0;i<pattern.word.length;i++){
                const cellValKey = `${pattern.row + i}_${pattern.col}`;
                chars.push(cellVals[cellValKey]);
            }
        }

        chars = chars.map(c=>c==='' ? '*' : c);
    
        const word = chars.join('');

        return word;        
    
    };
};

export const findContainingPatternsForCellClickedComponent = ({horizontalPatterns,verticalPatterns}) => {
  
return (cellRow, cellCol) => {
    const match = {};
    const horizontalMatch = horizontalPatterns.filter((p) => {
      const { row, col, word } = p;
      return (
        row === cellRow && cellCol >= col && cellCol <= col + word.length - 1
      );
    });
    const verticalMatch = verticalPatterns.filter((p) => {
      const { row, col, word } = p;
      return (
        col === cellCol && cellRow >= row && cellRow <= row + word.length - 1
      );
    });

    match.horizontal = _.first(horizontalMatch);
    match.vertical = _.first(verticalMatch);

    //console.log('match horizontal', match.horizontal ? match.horizontal.word: '');
    //console.log('match vertical',match.vertical ? match.vertical.word : '');

    return match;
  };
};

export const checkWord = (puzzleDetail,cellVals,findContainingPatternsForCellClicked)=> (row,col)=>{

    //const {horizontalPatterns,verticalPatterns} = getPuzzleData(puzzleDetail);
    const {horizontal,vertical} = findContainingPatternsForCellClicked(row,col);

    const wordsFound = {};

    if(!!horizontal){
        const wordHorizontal = getCurrentPatternInput(cellVals)(horizontal);

        if(wordHorizontal){
            wordsFound.horizontal = wordHorizontal;
        }
    }

    if(!!vertical){
        const wordVertical = getCurrentPatternInput(cellVals)(vertical);

        if(wordVertical){
            wordsFound.vertical = wordVertical;
        }
    }

    return wordsFound;

};

const removePatternFromFoundPatternsComponent = 
    ({foundPatternCells,foundPatterns,setFoundPatternCells,setFoundPatterns})=>(patterns)=>{
    
    if(patterns.length === 0) return;

    let newFoundPatterns = [...foundPatterns];
    let newFoundPatternCells = {...foundPatternCells};

    const checkIfAnyPatternsContainsCell = (patterns,key)=>{
        const [row,col] = key.split('_').map(part=>+part);
        const pattern = patterns.some(p=>patternContainsCell(p,row,col));

        return !!pattern;
    };

    for(let pattern of patterns){

        const wasAFoundPatternBefore = foundPatterns.some(p=>p === pattern);  
       
        if(wasAFoundPatternBefore){
            
            newFoundPatterns = newFoundPatterns.filter(p=>p !== pattern);

            patternsFoundSingleton.remove(pattern);
    
            const patternCells = findPatternCells(pattern);  
            
            for(let key of Object.keys(patternCells)){

                const foundPatternExistsContainingCell = checkIfAnyPatternsContainsCell(newFoundPatterns,key);
                if(!foundPatternExistsContainingCell){
                    delete newFoundPatternCells[key];
                }
            }
   
            /* Object.keys(patternCells).forEach(key=>{
                

            }); */    
            
        }
    }

    setFoundPatterns(newFoundPatterns);
    setFoundPatternCells(newFoundPatternCells);
    
};

export const checkAnswerComponent = 
    ({puzzleDetail,cellVals,
        findContainingPatternsForCellClicked,
        foundPatternCells,foundPatterns,
        setFoundPatternCells,setFoundPatterns})=> async (row,col)=>{
    
    const removePatternFromFoundPatterns = removePatternFromFoundPatternsComponent({foundPatternCells,foundPatterns,setFoundPatternCells,setFoundPatterns});

    const {puzzleId} = getPuzzleData(puzzleDetail);
    
    const wordsFound = checkWord(puzzleDetail,cellVals,findContainingPatternsForCellClicked)(row,col);

    const {horizontal,vertical} = findContainingPatternsForCellClicked(row,col);

    let result = {};

    const horizontalAlreadyFound = patternsFoundSingleton.exists(horizontal);
    const verticalAlreadyFound = patternsFoundSingleton.exists(vertical);

    const patternsToRemoveFromFoundPatterns = [];

    const addPatternsToRemove = (pattern)=>{
        const wasAFoundPatternBefore = foundPatterns.some(p=>p === pattern);
        if(!wasAFoundPatternBefore) return;
        patternsToRemoveFromFoundPatterns.push(pattern);
    };

    

        if(wordsFound.horizontal){

            if (!horizontalAlreadyFound) {
              const checkResult = await api.checkAnswer(
                puzzleId,
                wordsFound.horizontal,
                horizontal.row,
                horizontal.col,
                0
              );
              
              result.horizontal = {
                pattern: horizontal,
                word: wordsFound.horizontal,
                checkResult,
              };

              if (!checkResult.isCorrect) {
                //removePatternFromFoundPatterns(horizontal);
                //patternsToRemoveFromFoundPatterns.push(horizontal);
                addPatternsToRemove(horizontal);
              }
            }
            
            
        }else{
            
            //removePatternFromFoundPatterns(horizontal);
             
            addPatternsToRemove(horizontal);
    
            //patternsToRemoveFromFoundPatterns.push(horizontal);
            
        }

    
    
   

    if(wordsFound.vertical){

        if (!verticalAlreadyFound) {
          const checkResult = await api.checkAnswer(
            puzzleId,
            wordsFound.vertical,
            vertical.row,
            vertical.col,
            1
          );

          result.vertical = {
            pattern: vertical,
            word: wordsFound.vertical,
            checkResult,
          };

          if (!checkResult.isCorrect) {
            //removePatternFromFoundPatterns(vertical);
            //patternsToRemoveFromFoundPatterns.push(vertical);
            addPatternsToRemove(vertical);
          }
        }
        
        
    }else{
        //removePatternFromFoundPatterns(vertical);
        //patternsToRemoveFromFoundPatterns.push(vertical);
        addPatternsToRemove(vertical);
    }

    if(patternsToRemoveFromFoundPatterns.length > 0){
        console.log('WILL REMOVE PATTERNS FROM FOUND!',patternsToRemoveFromFoundPatterns);
        removePatternFromFoundPatterns(patternsToRemoveFromFoundPatterns);
    }

    

    return result;
};

export const getPuzzleData = (puzzleDetail)=>{

        //console.log(puzzleDetail);
        const grid = puzzleDetail.puzzle.grid ? puzzleDetail.puzzle.grid : [];
    
        const patterns = puzzleDetail.puzzle.patterns ? puzzleDetail.puzzle.patterns : [];
        const horizontalPatterns = patterns.filter(p=>p.direction === 0);
        const verticalPatterns = patterns.filter(p=>p.direction === 1); 
        
        const puzzleId = puzzleDetail.puzzle.puzzleId;

        return {puzzleId,grid,patterns,horizontalPatterns,verticalPatterns};

};

